import { Tutorial } from '../tutorial.model';

export const SUPORTE_COMPLEMENTAR_TOURS: Tutorial[] = [
  {
    id: 'suporte-novidades', rota: '/painel/suporte/novidades', passos: [
      { alvo: 'novidades.cabecalho', titulo: 'Conheça as mudanças do sistema',
        corpo: 'Novidades apresenta as versões do Mais Gestão, começando pela mais recente. Central de suporte retorna aos seus chamados.' },
      { alvo: 'novidades.versao', alvoAlternativo: 'novidades.cabecalho', titulo: 'Leia o que mudou em cada versão',
        corpo: 'Cada cartão reúne versão, data, descrição e os itens publicados. Quando houver artigo relacionado, abra-o para consultar a orientação de uso.' },
      { alvo: 'novidades.anteriores', titulo: 'Consulte versões anteriores',
        corpo: 'Carregar versões anteriores acrescenta publicações mais antigas. Ao chegar ao fim, a página informa que você consultou a primeira versão publicada.' },
    ],
  },
  {
    id: 'suporte-acesso-remoto', rota: '/painel/suporte/acesso-remoto', interativo: true, passos: [
      { alvo: 'acesso-remoto.gerar', titulo: 'Autorize um atendimento remoto quando precisar',
        corpo: 'Gerar código cria uma autorização para o atendente entrar na sua empresa e abre uma janela com o código, a opção de copiar e o tempo restante. O código vale por 15 minutos e pode ser usado uma vez. Informe-o ao atendente pelo canal do atendimento.' },
      { alvo: 'acesso-remoto.sessoes', titulo: 'Acompanhe quem está conectado',
        corpo: 'Sessões mostra atendente, tipo de acesso, início e situação, das mais novas para as mais antigas. A lista permite distinguir sessões ativas das já encerradas.' },
      { alvo: 'acesso-remoto.encerrar', alvoAlternativo: 'acesso-remoto.sessoes', titulo: 'Encerre uma sessão quando terminar',
        corpo: 'Uma sessão ativa oferece Encerrar na própria linha. Confira o atendente e confirme a ação para interromper aquele acesso.' },
    ],
  },
];
